var render = function render(){var _vm=this,_c=_vm._self._c;return _c('u-btn',{staticClass:"full-width",attrs:{"loading":_vm.loading,"icon":"security","label":"Análise Cadastral","color":"green","no-caps":""},on:{"click":_vm.analiseCadastral}})
}
var staticRenderFns = []

export { render, staticRenderFns }